import BossModel from "@/models/BossModel";

export default class AddressType extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'address-type';

    /**
     *
     * @type {string}
     */
    static entity = 'addresstypes';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            is_active: this.attr(null),
        }
    }

}
